/**
 * Media for the marketing landing.
 *
 * - Local `npm start`: /landing (run copy-landing-assets when the monorepo is present)
 * - Production (Vercel): design-preview CDN by default (chainz-landing is not in this repo)
 * - Override: REACT_APP_LANDING_ASSETS=/landing or a full URL base
 */
const remoteBase = "https://chainz-landing-page.vercel.app/uploads";
const localBase = `${process.env.PUBLIC_URL || ""}/landing`;

const envBase = process.env.REACT_APP_LANDING_ASSETS;
const defaultBase =
  envBase === "remote"
    ? remoteBase
    : envBase && envBase !== "local"
      ? envBase
      : envBase === "local" || process.env.NODE_ENV !== "production"
        ? localBase
        : remoteBase;

export const ASSET_BASE = defaultBase.replace(/\/$/, "");
export const REMOTE_ASSET_BASE = remoteBase;

function url(path) {
  return `${ASSET_BASE}/${path}`;
}

export const assets = {
  logo: url("logos/chainz-logo.png"),
  logoFull: url("logos/logo-full.png"),
  hero: url("images/hero-warehouse.jpg"),
  supplyChain: url("images/supplychain.png"),
  howPoster: url("images/how-it-works-poster.jpg"),
  howVideo: url("videos/how-it-works.mp4"),
  categoriesVideo: url("videos/categories-box.mp4"),
  daniel: url("images/daniel.JPG"),
  kareem: url("images/Kareem.jpeg"),
  og: url("images/og-image.jpg"),
  integrations: {
    Shopify: url("integrations/int-shopify.png"),
    Bosta: url("integrations/int-bosta.png"),
    Blink: url("integrations/int-blink.png"),
    "Confirm It": url("integrations/int-confirmit.png"),
    EcomHQ: url("integrations/int-hq.png"),
    Fincart: url("integrations/int-fincart.png"),
  },
};

/** If a local /landing asset 404s, retry from the design-preview uploads host. */
export function onAssetError(e) {
  const el = e?.currentTarget;
  if (!el || el.dataset.fallback === "1") return;
  const src = el.getAttribute("src") || "";
  if (src.includes("/uploads/") && src.includes("chainz-landing-page.vercel.app")) return;
  let rel = "";
  if (src.includes("/landing/")) {
    rel = src.slice(src.indexOf("/landing/") + "/landing/".length);
  } else {
    return;
  }
  el.dataset.fallback = "1";
  el.src = `${remoteBase}/${rel}`;
}
